// extracted by mini-css-extract-plugin
module.exports = {"grid":"deduction-grid_grid__ODx4-"};